// ***************************************
// gameController
//
// Each game must include a game controller that handle the running of
// the game. It must contain some methods that are called by the flow controller.
// The object is created by the flow controller.
//
// This version is just a template, although many games would not need more than just this.
//
// Copyright 2015 Tingly Games B.V.
// Last Changed: 12-10-2015
// ***************************************
import { gameController, customMessagecontroller, instantNotificationsService, flowController } from "../../game_theme/flow_fb/flowController";
import { tbGame } from "../engine/tbGame";
import { tgfHooks } from "../framework/hooks/hooks";
import { tgfAudio } from "../framework/tgfAudio";
import { tgfDictionary } from "../framework/tgfDictionary";
import { tgfGraphics } from "../framework/tgfGraphics";
import { tgfSettings } from "../framework/tgfSettings";
import { LevelSettings, GamebotSettings } from "../settings/Settings";
import { SoundManager } from "../settings/SoundManager";
import { gameSettings } from "../settings/gameSettings";
import { AngryAnalytics } from "./Analytics/Analytics";
import { ExpManager } from "./ExpManager";
import { FriendManager } from "./FriendManager";
import { NewGameDialog } from "./LobbyCode/NewGameDialog";
import { WarningDialog } from "./LobbyCode/WarningDialog";
import { NudgeFactory } from "./NudgeFactory";
import { PlayController } from "./PlayController";
import { ReplayTransitionToken } from "./ReplayTransitionToken";
// Directives for jslint
/*global tbGame */
/*global tgfSettings */
/*global gameSettings, PlayController */
export var playController = null; // Object controlling the play of the game
// The constructor 
export var GameController = function () {
    "use strict";
    // Merge the settings into the total settings
    // When required settings can also be computed here and other initialization can take place
    tgfSettings.mergeSettings(gameSettings());
    this.mightyScopeEnd = Number.MAX_SAFE_INTEGER;
    this.mightyScopeDialogEnabled = true;
};
// ***************************************
// Required methods
// ***************************************
// Start playing an instance (level) of the game
GameController.prototype.startPlay = function (lobbyData, context, isRandom, isAI, isFake, expandedLobbyData, onGameStart, onUserInput, levelIndex) {
    "use strict";
    var self = this;
    var showReplayTransition = false;
    if (expandedLobbyData) {
        if ((expandedLobbyData["lastTurnID"] &&
            expandedLobbyData["lastTurnID"] !== tgfHooks.getPlayerID()) &&
            (expandedLobbyData["watchedFinalReplay"] == false ||
                typeof (expandedLobbyData["watchedFinalReplay"]) === 'undefined')) {
            showReplayTransition = true;
        }
        else {
            showReplayTransition = false;
        }
    }
    else {
        showReplayTransition = false;
    }
    if (lobbyData && lobbyData["url"] && levelIndex !== undefined) {
        var _levelIndex = levelIndex;
        var levelVersion = expandedLobbyData["levelVersion"] || 1;
        if (LevelSettings.levelList[_levelIndex].levelExtra.version !== levelVersion) {
            // gamesBackendService.removePlayerFromMatches([lobbyData["url"]]);
            lobbyData = {};
            showReplayTransition = false;
        }
    }
    if (!isAI && context && context !== tgfHooks.getContextID()) {
        tgfHooks.switchContext(context, function () {
            if (flowController.lobbyScreenDialog) {
                flowController.lobbyScreenDialog.deactivate();
            }
            AngryAnalytics.reportSwitching();
            self._handleReplayTransition(lobbyData, isRandom, onGameStart, showReplayTransition);
        }, function (error) {
            if (error["code"] == "SAME_CONTEXT") {
                self._handleReplayTransition(lobbyData, isRandom, onGameStart, showReplayTransition);
            }
            else if (error["code"] === "USER_INPUT") {
                console.log("User closed context switch interface");
                if (onUserInput) {
                    onUserInput();
                }
            }
            else {
                console.log("Can't switch ctx: " + error);
            }
        });
    }
    else {
        if (flowController.lobbyScreenDialog) {
            flowController.lobbyScreenDialog.deactivate();
        }
        SoundManager.playEffect(SoundManager.UI_STATE.ENTER_GAME, SoundManager.UICollection, 0, false);
        tgfAudio.stop("music");
        if (!isAI && showReplayTransition) {
            self.transition = new ReplayTransitionToken(function () {
                self.addThePlayController(lobbyData, isRandom, false, false);
            }, function () {
                if (onGameStart) {
                    onGameStart();
                }
            });
        }
        else {
            self.addThePlayController(lobbyData, isRandom, isAI, isFake);
            if (onGameStart) {
                onGameStart();
            }
        }
    }
};
GameController.prototype._handleReplayTransition = function (lobbyData, isRandom, onGameStart, showReplayTransition) {
    var self = this;
    SoundManager.playEffect(SoundManager.UI_STATE.ENTER_GAME, SoundManager.UICollection, 0, false);
    tgfAudio.stop("music");
    if (showReplayTransition) {
        self.transition = new ReplayTransitionToken(function () {
            self.addThePlayController(lobbyData, isRandom, false, false);
        }, function () {
            if (onGameStart) {
                onGameStart();
            }
        });
    }
    else {
        self.addThePlayController(lobbyData, isRandom, false, false);
        if (onGameStart) {
            onGameStart();
        }
    }
};
GameController.prototype.addThePlayController = function (lobbyData, isRandom, isAI, isFake) {
    "use strict";
    ExpManager.loadAllFriendRanks().then(function () {
        if (playController) {
            tbGame.removeTokens("play");
            tbGame.removeTokenTags(playController, ['play']);
        }
        playController = new PlayController(lobbyData, isRandom, isAI, isFake);
        tbGame.addToken(playController);
        tbGame.addTokenTags(playController, ["play"]);
    });
};
// Stop playing an instance (level) the game, cleaning it up, should take care of removing all tokens
GameController.prototype.stopPlay = function () {
    "use strict";
    tbGame.removeTokens("play");
    tbGame.removeTokenTags(playController, ['play']);
    playController = null;
    flowController.showLobby(false);
};
// Pause playing (called e.g. when the options screen shows up) It should stack!
GameController.prototype.pausePlay = function () {
    "use strict";
    if (playController && playController.ui) {
        playController.ui.deactivate();
        if (playController.uiController.uiPowerUps) {
            playController.uiController.uiPowerUps.deactivate();
        }
    }
    tbGame.pauseTokens("play");
};
// Resumes playing (called e.g. when the options screen disappears) It should stack!
GameController.prototype.resumePlay = function () {
    "use strict";
    tbGame.resumeTokens("play");
};
GameController.prototype.pauseUI = function () {
    "use strict";
    tbGame.pauseToken(playController.ui);
};
GameController.prototype.resumeUI = function () {
    "use strict";
    tbGame.resumeToken(playController.ui);
};
/*
    onBlockInput - Called after creating the dialog; for handling input blocking
    onCancel - Called when the dialog is cancelled/closed
    onNewGameStarted - Called when the new game is created
 */
GameController.prototype.showNewGameDialog = function (onBlockInput, onCancel, onNewGameStarted) {
    "use strict";
    var self = this;
    self.newGamePopup = new NewGameDialog({ x: tgfGraphics.areaWidth / 2, y: tgfGraphics.areaHeight / 2 }, function () {
        if (onCancel) {
            onCancel();
        }
    }, function () {
        gameController.startNewGame(onNewGameStarted, onCancel);
    }, function () {
        gameController.startPlay({}, 0, false, true, true, null, function () {
            onNewGameStarted();
        });
        /*
            self.randomGamePopup = new RandomOpponentDialog({x: tgfGraphics.areaWidth/2, y: tgfGraphics.areaHeight/2},
                function(){ // on pressed back
                    self.newGamePopup.show();
                },
                function(){ // on pressed cancel
                    if (onCancel) {
                        onCancel();
                    }
                });

        self.randomGamePopup.show();
        */
    }, function () {
        gameController.startPlay({}, 0, false, true, false, null, function () {
            onNewGameStarted();
        });
    });
    self.newGamePopup.show();
    onBlockInput();
};
GameController.prototype.closeNewGameDialogs = function () {
    "use strict";
    if (gameController.randomGamePopup) {
        gameController.randomGamePopup.hide();
        gameController.randomGamePopup.free();
        gameController.randomGamePopup = null;
    }
    if (gameController.newGamePopup) {
        gameController.newGamePopup.hide();
        gameController.newGamePopup.free();
        gameController.newGamePopup = null;
    }
};
GameController.prototype.onShowLobby = function (reason) {
    "use strict";
    if (reason == "notYourTurn") {
        if (flowController.lobbyScreenDialog) {
            flowController.lobbyScreenDialog.showNotYourTurn();
        }
        else if (playController && playController.waitingScreen && playController.waitingScreen.newMatchButton) {
            playController.waitingScreen.newMatchButton.activate();
            playController.waitingScreen.backToLobbyButton.activate();
            playController.waitingScreen.watchVideo.activate();
            playController.waitingScreen.showNotYourTurn();
            if (playController.replayQueued) {
                playController.waitingScreen.notYourTurn.onClose = function () {
                    playController.replayQueued = false;
                    playController.processData(playController.storedReplayData);
                };
            }
        }
    }
    else {
        flowController.showLobby(false);
    }
};
GameController.prototype.startNewGame = function (uiCallback, onCancel) {
    "use strict";
    var self = this;
    if (playController) {
        playController.chooseContextIsOpen = true;
    }
    tgfHooks.chooseContext(function () {
        if (playController) {
            playController.chooseContextIsOpen = false;
        }
        var isGroup = tgfHooks.isSizeBetween(3, null);
        if (!isGroup) {
            AngryAnalytics.reportSwitching();
            self.resumeOrStartNewGame(uiCallback, uiCallback, self.onShowLobby, true);
        }
        else {
            console.log("Groups are not allowed");
            if (onCancel) {
                onCancel();
            }
        }
    }, function (error) {
        if (playController) {
            playController.chooseContextIsOpen = false;
        }
        if (error["code"] == "SAME_CONTEXT") {
            var isGroup = tgfHooks.isSizeBetween(3, null);
            if (!isGroup) {
                self.resumeOrStartNewGame(uiCallback, uiCallback, self.onShowLobby, true);
            }
            else {
                console.log("Groups are not allowed");
                if (onCancel) {
                    onCancel();
                }
            }
        }
        else if (onCancel && error["code"] == "USER_INPUT") {
            if (playController && playController.replayQueued) {
                playController.replayQueued = false;
                playController.processData(playController.storedReplayData);
            }
            else {
                self.chooseAFriend = new WarningDialog({
                    text: tgfDictionary.getText("CHALLENGE_FRIEND_INFO_TEXT"),
                    width: 1000,
                    onClose: function () {
                        self.chooseAFriend = null;
                    }
                });
                self.chooseAFriend.show();
            }
            onCancel();
        }
        else {
            console.log("Choose context fail", error);
            if (onCancel) {
                onCancel();
            }
        }
    }, { filters: ["INCLUDE_EXISTING_CHALLENGES"], maxSize: 2 });
};
GameController.prototype.resumeOrStartNewGame = function (onNewGame, onResume, onFail, allowNewGame) {
    var ctx = tgfHooks.getContextID();
    // var promise = gamesBackendService.getLastMatchFromContext(ctx, ["lobby", "levelSettings"]);
    var promise = Promise.resolve({});
    var self = this;
    promise.then(function (data) {
        if (data && data["lobby"] && data["levelSettings"]) {
            var myTurn = data["lobby"]["lastTurnID"] !== tgfHooks.getPlayerID();
            var isGameOver = data["lobby"]["state"] === "GAMEOVER";
            var count = data["lobby"]["watchedFinalReplay"];
            // Level version mismatch
            var levelIndex = data["levelSettings"]["levelIndex"];
            var levelVersion = data["lobby"]["levelVersion"] || 1;
            var invalidLevel = LevelSettings.levelList[levelIndex].levelExtra.version !== levelVersion;
            if (isGameOver && count !== 0 || invalidLevel && myTurn) {
                if (allowNewGame) {
                    if (invalidLevel && data && data["id"]) {
                        // gamesBackendService.removePlayerFromMatches([data["id"]]);
                    }
                    gameController.startPlay({}, ctx, false, false, false, data ? data["lobby"] : null, function () {
                        if (onNewGame) {
                            tgfAudio.stop("music");
                            onNewGame();
                        }
                    }); //start new game
                }
                else if (onFail) {
                    onFail("newGameNotAllowed");
                }
            }
            else if (myTurn) {
                customMessagecontroller.queueMessages("group");
                if (invalidLevel) {
                    // gamesBackendService.removePlayerFromMatches([data["id"]]);
                    gameController.startPlay({}, ctx, false, false, false, data ? data["lobby"] : null, function () {
                        if (onNewGame) {
                            tgfAudio.stop("music");
                            onNewGame();
                        }
                    }); //start new game
                }
                else {
                    gameController.startPlay({ "url": data["id"] }, ctx, false, false, false, data ? data["lobby"] : null, function () {
                        if (onResume) {
                            if (flowController.lobbyScreenDialog) {
                                AngryAnalytics.reportLobbyEntry(false, data["levelSettings"]["levelIndex"], data["id"]);
                            }
                            onResume();
                        }
                    }); //resume game
                }
            }
            else {
                customMessagecontroller.queueMessages("poke");
                if (onFail) {
                    onFail("notYourTurn");
                }
            }
        }
        else {
            customMessagecontroller.queueMessages("group");
            if (allowNewGame) {
                gameController.startPlay({}, ctx, false, false, false, data ? data["lobby"] : null, function () {
                    if (onNewGame) {
                        tgfAudio.stop("music");
                        onNewGame();
                    }
                }); //start new game
            }
            else if (onFail) {
                onFail("newGameNotAllowed");
            }
        }
    });
};
GameController.prototype.scheduleRetentionNotifications = function () {
    return;
    var id = flowController.playerID;
    // clearing up all notifications from gamebot server
    instantNotificationsService.cancelAllScheduleNotifications(id).then(function () {
        var indices = gameController.createShuffledIndexArray(GamebotSettings.delays.length);
        for (var i = 0; i < indices.length; i++) {
            var notification = new InstantNotification();
            var msgData = GamebotSettings.messages[indices[i]];
            notification["reminderMessage"] = tgfDictionary.getText(msgData.message);
            notification["imageUrl"] = msgData.imageUrl;
            var currentDate = new Date(Date.now());
            currentDate.setHours(17, 30, 0, 0);
            notification["scheduleTime"] = new Date(currentDate.getTime() + GamebotSettings.delays[i]);
            notification["buttons"] = [tgfDictionary.getText(msgData.CTA)];
            notification["payloads"] = [{ "tag": "gamebot" + indices[i] }];
            instantNotificationsService.scheduleNotification(id, notification).then(function (notificationId) {
            }, function (reason) {
                console.error("Couldn't schedule the instant message: " + reason);
            });
        }
    });
};
GameController.prototype.handleSuggestedFriendNotification = function () {
    this._setOwnSuggestedFriendImage();
    this._scheduleSuggestedFriendNotification();
};
GameController.prototype._setOwnSuggestedFriendImage = function () {
    var image = { base64: NudgeFactory.GetPremadeNudge("suggestedFriends", 0, {}) };
    instantNotificationsService.setSuggestedFriendSharedImage(image).then(function () {
    }, function (reason) {
        console.error("Failed to set suggested friend image with reason: " + reason);
    });
};
GameController.prototype._scheduleSuggestedFriendNotification = function () {
    // make list of suggested player messages without images and send through GameSparksInstantNotificationsService.prototype.setSuggestedFriendNotifications
    var suggestedPeople = FriendManager.getSuggestedFriends(50);
    var messages = [];
    for (var i = 0; i < suggestedPeople.length; i++) {
        var messageOptions = [{
                friendId: suggestedPeople[i].id,
                title: String.format(tgfDictionary.getText("BOT_SUGGESTEDFRIENDS_1_HEADER"), suggestedPeople[i].name),
                subtitle: tgfDictionary.getText("BOT_SUGGESTEDFRIENDS_1_SUBTEXT"),
                buttons: [{
                        text: "Play against " + suggestedPeople[i].name,
                        playerId: suggestedPeople[i].id,
                    }]
            },
            {
                friendId: suggestedPeople[i].id,
                title: String.format(tgfDictionary.getText("BOT_SUGGESTEDFRIENDS_2_HEADER"), suggestedPeople[i].name),
                subtitle: String.format(tgfDictionary.getText("BOT_SUGGESTEDFRIENDS_2_SUBTEXT"), suggestedPeople[i].name),
                buttons: [{
                        text: "Play against " + suggestedPeople[i].name,
                        playerId: suggestedPeople[i].id,
                    }]
            },
            {
                friendId: suggestedPeople[i].id,
                title: String.format(tgfDictionary.getText("BOT_SUGGESTEDFRIENDS_3_HEADER"), suggestedPeople[i].name),
                subtitle: tgfDictionary.getText("BOT_SUGGESTEDFRIENDS_3_SUBTEXT"),
                buttons: [{
                        text: "Play against " + suggestedPeople[i].name,
                        playerId: suggestedPeople[i].id,
                    }]
            }];
        var message = messageOptions[Math.floor(Math.random() * messageOptions.length)];
        messages.push(message);
    }
    instantNotificationsService.setSuggestedFriendNotifications(messages);
};
GameController.prototype.scheduleMatchNotifications = function (matchId, nextPlayerId) {
    var image = NudgeFactory.GetPremadeNudge('matchNotification', 0, {});
    var messages = [{
            title: String.format(tgfDictionary.getText("BOT_MATCHNOTIFICATION_1_HEADER"), tgfHooks.getPlayerName()),
            subtitle: tgfDictionary.getText("BOT_MATCHNOTIFICATION_1_SUBTEXT"),
            image: image,
            buttons: [{
                    text: "Play!",
                    contextId: tgfHooks.getContextID(),
                }]
        },
        {
            title: String.format(tgfDictionary.getText("BOT_MATCHNOTIFICATION_2_HEADER"), tgfHooks.getPlayerName()),
            subtitle: tgfDictionary.getText("BOT_MATCHNOTIFICATION_2_SUBTEXT"),
            image: image,
            buttons: [{
                    text: "Play!",
                    contextId: tgfHooks.getContextID(),
                }]
        },
        {
            title: String.format(tgfDictionary.getText("BOT_MATCHNOTIFICATION_3_HEADER"), tgfHooks.getPlayerName()),
            subtitle: tgfDictionary.getText("BOT_MATCHNOTIFICATION_3_SUBTEXT"),
            image: image,
            buttons: [{
                    text: "Play!",
                    contextId: tgfHooks.getContextID(),
                }]
        }];
    var message = messages[Math.floor(Math.random() * messages.length)];
    instantNotificationsService.addEndOfTurnMatchNofitication(matchId, nextPlayerId, message);
};
GameController.prototype.createShuffledIndexArray = function (length) {
    var arr = [];
    for (var i = 0; i < length; i++) {
        arr.push(i);
    }
    return this.shuffleArray(arr);
};
// The shuffle algorithm is the Fisher-Yates (aka Knuth) Shuffle
GameController.prototype.shuffleArray = function (array) {
    var currentIndex = array.length, temporaryValue, randomIndex;
    // While there remain elements to shuffle...
    while (0 !== currentIndex) {
        // Pick a remaining element...
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;
        // And swap it with the current element.
        temporaryValue = array[currentIndex];
        array[currentIndex] = array[randomIndex];
        array[randomIndex] = temporaryValue;
    }
    return array;
};
